import type { FeedbackReason, FeedbackTrigger } from '../enums/feedback';
import eventsCommonNames from '../events/common';
import { useSendEvent } from '../useSendEvent';

const useShowFeedbackModal = ({ reason }: { reason: FeedbackReason }) =>
	useSendEvent<{
		modal_view_trigger?: FeedbackTrigger;
	}>(
		eventsCommonNames.feedbackModalShown,
		{ modal_view_reason: reason },
		{ forceSendDemoUser: true }
	);

const annalsCommon = {
	useShowFeedbackModal,
};

export default annalsCommon;
